import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { WhatCustomersSay } from '../../shared';

Builder.registerComponent(WhatCustomersSay, {
    name: BUILDER_DIVIDER_NAMES.WhatCustomersSay,
});
